// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/green.scss
// module id = 590
// module chunks = 376